import {TIME} from '@stubhub/general-utils';
import {formatLocation} from '@stubhub/location-util';
import {logger} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

/**
 * Method to get the Search Location API query parameters.
 * @param urlParams [object] The Default Params to be used as part of the request.
 * @returns urlParams [object] The API Request Parameters.
 *
 */
export function getSearchLocationQuery(urlParams) {
  const defaults = {
    unit: 'mi',
    shstore: 1,
    rows: 5,
    nocache: `${+new Date()}-${Math.floor(
      Math.random() * TIME.MILLIS_OF_SECOND * TIME.MILLIS_OF_SECOND * TIME.MILLIS_OF_SECOND
    )}`,
  };
  urlParams = {...defaults, ...urlParams};

  if (typeof urlParams.point !== 'undefined') {
    urlParams.sort = 'distance asc';
    urlParams.radius = '3000';
  } else if (typeof urlParams.ipDetect === 'undefined') {
    urlParams.sort = 'population desc';
  }

  return urlParams;
}

/**
 * Method to Make the Search Location API request to get the Locations for the given params.
 * @param urlParams [object] The Default Params to be used as part of the request.
 * @param locale [String] The Current locale of the application.
 * @returns Promise [Promise] The API Promise.
 *
 */
export function searchLocation(urlParams, locale) {
  if (typeof urlParams === 'string') {
    urlParams = {
      q: urlParams,
    };
  }

  return get({
    host: process.env.REACT_APP_API_HOST,
    path: '/search/locations/v3',
    query: getSearchLocationQuery(urlParams),
    headers: {
      'Accept-Language': locale,
      Authorization: process.env.REACT_APP_API_SECRET,
    },
    json: true,
    logger,
  }).then((response) => {
    return response.locations.map((loc = {}, index) => {
      return Object.assign(loc, {
        index,
        key: loc.geoNameId || `${loc.postalCode}${index}`,
        name: formatLocation(loc, locale?.split('-')[1].toUpperCase(), 'short'),
      });
    });
  });
}

/**
 * Method to get the Location of the User from the Browser Geolocation API.
 * @returns Promise [Promise] The API Promise.
 *
 */
export function getLocationFromHTML5Api() {
  return new Promise((resolve, reject) => {
    const DAYS = 15;
    const maxAgeInMilliseconds = DAYS * TIME.HOURS_OF_DAY * TIME.MINS_OF_HOUR * TIME.MILLIS_OF_SECOND;

    if (navigator && navigator.geolocation && typeof navigator.geolocation.getCurrentPosition === 'function') {
      navigator.geolocation.getCurrentPosition(
        (location) => {
          const point = [location.coords.latitude, location.coords.longitude];
          resolve(point);
        },
        reject,
        {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: maxAgeInMilliseconds,
        }
      );
    } else {
      reject('browser doesn\'t support GeoLocation API');
    }
  });
}
